import { render, staticRenderFns } from "./prodottoCarrelloCard.vue?vue&type=template&id=89cdb238&"
import script from "./prodottoCarrelloCard.vue.ts?vue&type=script&lang=ts&"
export * from "./prodottoCarrelloCard.vue.ts?vue&type=script&lang=ts&"
import style0 from "./prodottoCarrelloCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports